/**
 * Versão vigente dos Termos de Uso e da Política de Privacidade — a mesma da
 * API (Src\Domain\Services\Account\LegalTerms::VERSION). Mudou o texto de forma
 * relevante? Suba as duas: quem aceitou a versão anterior vê o pedido de novo
 * aceite no próximo acesso.
 */
export const LEGAL_TERMS_VERSION = '2026-10-09';

/** Data exibida em "Última atualização" nas páginas /terms e /privacy. */
export const LEGAL_TERMS_UPDATED_AT = '9 de outubro de 2026';

/** Canal do Encarregado pelo tratamento de dados (DPO) e dos pedidos do titular. */
export const PRIVACY_CONTACT_EMAIL = 'contato@snapfy.ai';
